import * as React from "react";
import { TextBoxEditor } from "../../../../react-core/Html/TextBoxEditor";
import { ContentFilter, ContentTable } from "../Resource/Content";
import { Pager } from "../../../../react-core/Html/Pager";
import { AccountInClosuretAction } from "../Actions/AccountInClosureAction";
import { ClosingAccountStore } from "../Stores/Variable";
import { AccountInClosure } from "../../../../Wrap/Models/Domains/Account/AccountClosure/AccountInClosure";
import { PartLoading } from "../../../../react-core/Html/PartLoading";
import { AccountInClosureCollectionModel } from "../../../../Wrap/Models/Domains/Account/AccountClosure/AccountInClosureCollectionModel";
import { FormComponent } from "../../../../react-core/Html/FormComponent";
import { checkPermission } from "../../../Shared/Permission/PermissionHelper";
import { UserClaim } from "../../../../Wrap/Constants/Enums/UserClaim";

export type ISearchTableProps = React.Props<SearchTable>;

interface ISearchTableState {
    tableData: AccountInClosureCollectionModel;
    isLoading?: boolean;
    currentPage: number;
    pageSize: number;
    accountName: string;
    accountNum: string;
}

export class SearchTable extends FormComponent<ISearchTableProps, ISearchTableState> {
    constructor(props: any) {
        super(props);
        this.state = {
            tableData: null,
            isLoading: false,
            currentPage: 1,
            pageSize: 10,
            accountName: "",
            accountNum: "",
        };
        this.subscribeToStore(ClosingAccountStore, () => this.onClosingAccountStoreChange());
    }

    private onClosingAccountStoreChange(): void {
        const data = ClosingAccountStore.getData();
        this.setState({ tableData: data, isLoading: false });
    }

    private getData(pageIndex: number): void {
        const { accountName, accountNum } = this.state;
        const { pageSize } = this.state;
        const start = (pageIndex - 1) * pageSize + 1;
        const count = pageSize;
        this.setState({ isLoading: true });
        AccountInClosuretAction.getAccountClosureList(accountName, accountNum, start, count);
    }

    private onSearch(): void {
        this.getData(1);
    }

    private renderPagination() {
        const { currentPage, pageSize } = this.state;
        const { TotalNumberOfResults } = this.state.tableData;
        return (
            <div className="row">
                <div className="col-12 col-right">
                    <Pager
                        pager={{
                            CurrentPage: currentPage,
                            ResultsPerPage: pageSize,
                            TotalPages: TotalNumberOfResults / pageSize,
                            TotalRecords: TotalNumberOfResults,
                        }}
                        onChange={(recordsPerPage: number, pageIndex: number) => {
                            this.setState({ currentPage: pageIndex });
                            this.getData(pageIndex);
                        }}
                        recordsPerPageOptions={[10, 15, 20]}
                        isShowPerPageOptions={false}
                    />
                </div>
            </div>
        );
    }

    private renderFilter(): JSX.Element {
        const { accountName, accountNum } = this.state;
        return (
            <>
                <h1 className="page-heading">{ContentFilter.title}</h1>
                <div className="mb-24">
                    <div className="row">
                        <div className="col-12 col-sm-4">
                            <TextBoxEditor
                                value={accountName}
                                label={ContentFilter.accountName}
                                onChange={(v) => {
                                    this.setState({ accountName: v });
                                }}
                            />
                        </div>
                        <div className="col-12 col-sm-4">
                            <TextBoxEditor
                                value={accountNum}
                                label={ContentFilter.accountNum}
                                onChange={(v) => {
                                    this.setState({ accountNum: v });
                                }}
                            />
                        </div>
                        <div className="col-12 col-sm-4">
                            <button className="btn secondary label-offset" onClick={() => this.onSearch()}>
                                {ContentFilter.search}
                            </button>
                        </div>
                    </div>
                </div>
            </>
        );
    }

    private renderTableRow(data: AccountInClosure): JSX.Element {
        const url = `/clients/cash/regularwithdrawals.aspx?claccountid=${data.ClAccountId}#Current`;
        return (
            <tr key={data.ClAccountId}>
                <td>{data.AccountName}</td>
                <td>{data.ClAccountId}</td>
                <td>{data.AccountStatus}</td>
                <td>{data.Company}</td>
                <td className="text-right">
                    {checkPermission(UserClaim.AdviserPortalDluWithdrawalCanView) && (
                        <a href={url} className="forward-button">
                            <span className="icon" aria-hidden="true"></span>
                            <span className="text">{ContentTable.create}</span>
                        </a>
                    )}
                </td>
            </tr>
        );
    }

    private renderTable(data: AccountInClosure[]): JSX.Element {
        if (data.length === 0) {
            return <div id="noDataMsg">{ContentTable.noDataMsg}</div>;
        }
        return (
            <table className="data-table mb-40">
                <thead>
                    <tr>
                        <th>{ContentTable.accountName}</th>
                        <th>{ContentTable.accountNum}</th>
                        <th>{ContentTable.status}</th>
                        <th>{ContentTable.company}</th>
                        <th className="text-right"></th>
                    </tr>
                </thead>
                <tbody className="body-split">
                    {data.map((ele) => {
                        return this.renderTableRow(ele);
                    })}
                </tbody>
            </table>
        );
    }

    public render(): JSX.Element {
        const { tableData, isLoading } = this.state;
        if (!checkPermission(UserClaim.AdviserPortalNetworkAndFirmReadWrite)) {return null;}
        return (
            <>
                {this.renderFilter()}
                {isLoading ? (
                    <PartLoading isLoading={true}>
                        <div className="table-skeleton"></div>
                    </PartLoading>
                ) : (
                    tableData && this.renderTable(tableData.PageOfResults)
                )}
                {tableData && this.renderPagination()}
            </>
        );
    }
}
